import { useMemo } from 'react';

import { TUseLocalOptionsParams } from '@/shared/components/ui/form/components/searchable-select/hooks/use-local-options/use-local-options.types';
import { useOptions } from '@/shared/components/ui/form/components/searchable-select/hooks/use-options/use-options';

export const useLocalOptions = <TOptionShape>({
  debouncedSearch,
  value,
  options,
  getItemId,
}: TUseLocalOptionsParams<TOptionShape>) => {
  const { isSelected, groupedOptions } = useOptions({
    options,
    getItemId,
    value,
  });

  const filteredOptions = useMemo(() => {
    if (!debouncedSearch) {
      return groupedOptions;
    }

    const normalizedSearch = debouncedSearch.trim().toLowerCase();

    return groupedOptions.filter((option) =>
      option.label.toLowerCase().includes(normalizedSearch),
    );
  }, [debouncedSearch, options, groupedOptions]);

  return {
    options: filteredOptions,
    isSelected,
  };
};
